import React from "react";
import { Box, Typography } from "@mui/material";

const Empty = ({ children, msg }) => {
  return (
    <Box mt={3}>
      <Typography
        variant="h6"
        align="center"
      >
        {msg}
      </Typography>
      {children}
    </Box>
  );
};

export default Empty;
